import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';


const ProductDetails = () => {
  const search = useLocation().search;
  const proid = new URLSearchParams(search).get('proid');
  const [product, setProduct] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const response = await fetch(`https://www.hum.ujn.mybluehostin.me/new_clinet/snkb_api/product-details.php?proid=${proid}`);
        if (!response.ok) {
          throw new Error('Failed to fetch product details');
        }
        const productData = await response.json();
        setProduct(productData);
      } catch (error) {
        setError(error.message);
      }
    };

    fetchProductDetails();
  }, [proid]);

  if (error) {
    return <p>Error: {error}</p>;
  }

  if (!product) {
    return <p>Product not found</p>;
  }

  return (
    <div className="product-details">
      <section className="page-title centred">
        <div className="bg-layer" style={{ backgroundImage: `url('/assets/img/bg-img.png')` }}></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>{product.B_NO} - {product.category_name}</h1>
            <ul className="bread-crumb clearfix">
              <li><Link   to ="/">Home</Link></li>
              <li>{product.category_name}</li>
              <li>{product.B_NO}</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="shop-details">
        <div className="auto-container">
          <div className="shop-details-content">
            <div className="row clearfix">
              <div className="col-lg-6 col-md-12 col-sm-12 carousel-column">
                <div className="bxslider">
                  <div className="slider-content">
                    <figure className="image-box">
                   
                        <img id="mainImage" src={`/assets/img/${product.img}`} alt="" />
                    
                    </figure>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                <div className="content-box">
                  <h2>{product.B_NO}</h2>
                  <p>{product.category_name}</p>
                  <ul className="product-highlights clearfix" style={{ borderBottom: 'none' }}>
                    <li><h5>BEARING NO :</h5>{product.B_NO}</li>
                    <li><h5>ID :</h5>{product.B_ID} mm</li>
                    <li><h5>OD :</h5>{product.B_OD} mm</li>
                    <li><h5>THICKNESS : </h5>{product.TCHK} mm</li>
                    <li><h5>WEIGHT : </h5>{product.WEIGHT} kg</li>
                  </ul>
                  {(product.CATEGORY_ID === 1 || product.CATEGORY_ID === 8) && (
                    <p style={{ color: 'black' }}>
                      This product is also available in ZZ, 2RS, C3 Clearance, C4 Clearance, and C5 Clearance. For more details, please call us at <Link   to ="tel:+919930400377">+91 99304 00377</Link>
                    </p>
                  )}
                </div>
              </div>
            </div>
            <br />
            <div className="col-lg-12 col-md-12 col-sm-12 content-column" style={{ borderTop: '1px solid #e2e2e2' }}>
              <div className="content-box" style={{ paddingTop: '40px' }}>
                <div className="sec-title" style={{ marginBottom: '0px' }}>
                  <div className="text">
                    <p>{product.about || 'C'}</p>
                  </div>
                </div>
                <div className="sec-title">
                  <div className="text">
                    <p>{product.use || 'C'}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 content-column" style={{ borderTop: '1px solid #e2e2e2', borderRight: '1px solid #e2e2e2' }}>
                    <div className="content-box" style={{ paddingTop: '40px' }}>
                      <div className="sec-title" style={{ marginBottom: '18px' }}>
                        <h3>Pros</h3>
                      </div>
                      <div className="text">
                        <p>{product.pros}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 content-column" style={{ borderTop: '1px solid #e2e2e2' }}>
                    <div className="content-box" style={{ paddingTop: '40px' }}>
                      <div className="sec-title" style={{ marginBottom: '18px' }}>
                        <h3>Cons</h3>
                      </div>
                      <div className="text">
                        <p>{product.cons}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductDetails;
